export default __webpack_public_path__ + "static/media/regulatory--go-straight--g1.ed3c15a6.png";